import { useEffect } from "react";

import { useFormikContext } from "formik";
import { ICardBenefitPackage } from "library/types";
import { formatDateFieldForPayload } from "library/utils";
import { useTranslation } from "react-i18next";

import DatePickerField from "components/controls/DatePickerField";
import { getEnrollmentCancellationPossibilityDate } from "state/useGetEnrollmentCancellationPossibilityDate";

import { ConsentDependencyFields } from "./ConsentDependencyFields/ConsentDependencyFields";
import { GrecoSensitiveConsentTextSection } from "./GrecoSensitiveConsentTextSection";
import { SalaryDeductionConsent } from "./SalaryDeductionConsent/SalaryDeductionConsent";
type Props = {
  benefitPackage: ICardBenefitPackage;
  hideConsentFields?: boolean;
  showSalaryDeductionConsent?: boolean;
  isSalaryDeductionPaymentType?: boolean;
  showGrecoSensitiveDataConsentCheckbox?: boolean;
};
export function EnrollPackageFormItems({
  benefitPackage,
  hideConsentFields,
  showSalaryDeductionConsent,
  isSalaryDeductionPaymentType,
  showGrecoSensitiveDataConsentCheckbox,
}: Props) {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext<FormData>();

  const getCancellationPossibility = async (benefitPackage) => {
    const cancellationPossibility = await getEnrollmentCancellationPossibilityDate({
      countryCode: Number(benefitPackage.countryCode),
      clientInternalNumberGOS: Number(benefitPackage.clientInternalNumberGos),
      benefitPackageTag: Number(benefitPackage.benefitPackageTag),
      employeeDependentTag: benefitPackage.employeeDependentTag
        ? Number(benefitPackage.employeeDependentTag)
        : 0,
      employeeEnrollmentTag: Number(benefitPackage.employeeEnrollmentTag),
      dateOfEnrollment: formatDateFieldForPayload(values["dateOfEnrollment"]) || "",
    });
    setFieldValue("cancellationPossibility", new Date(cancellationPossibility));
  };

  useEffect(() => {
    if (values["dateOfEnrollment"] && !benefitPackage.cancellationPossibility) {
      getCancellationPossibility(benefitPackage);
    }
  }, [values["dateOfEnrollment"], benefitPackage?.cancellationPossibility]);

  return (
    <>
      <div data-help="benefits-enroll-date">
        <DatePickerField
          required
          minDate={new Date()}
          name="dateOfEnrollment"
          value={values["dateOfEnrollment"] as Date}
          setFieldValue={setFieldValue}
          label={t("hbh.dateOfEnrollment.label")}
          error={""}
        />
      </div>
      <div data-help="benefits-enroll-cancellation-date">
        <DatePickerField
          disabled
          name="cancellationPossibility"
          value={values["cancellationPossibility"] as Date}
          setFieldValue={() => {
            return;
          }}
          label={t("hbh.cancellationPossibility.label")}
          error={""}
        />
      </div>
      {hideConsentFields ? null : <ConsentDependencyFields />}
      {showGrecoSensitiveDataConsentCheckbox && <GrecoSensitiveConsentTextSection />}

      {showSalaryDeductionConsent ? (
        <SalaryDeductionConsent isSalaryDeductionPaymentType={isSalaryDeductionPaymentType} />
      ) : null}
    </>
  );
}
